import { makeVar } from '@apollo/client';

export const orderingSelected = makeVar([]);

export const orderingInvoiceIssuedSelected = makeVar({});

export const orderingOfferSelected = makeVar([]);
